import Component from '@glimmer/component';

export default class GoalsWizardGoalsCheckboxItemComponent extends Component {
  get isDisabled() {
    return String(this.args.disableDescendantsOfGoalId) === 'true';
  }
}
